import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useGetUserPartnersQuery } from '@/api/queries/user';
import { StringMain, StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import usdPng from '/img/icons/usd.png';
import usdWebp from '/img/icons/usd.webp';

const EarnInfo: FC = () => {
  const { t } = useTranslation();
  const myCryptoPercent = useAppSelector(
    (state) => state.user.extendedInfo?.myCryptoPercent,
  );
  const { data } = useGetUserPartnersQuery({ page: 1 });

  const infoData: {
    title: string;
    description: string;
    image?: { png: string; webp: string };
    classNames?: {
      title?: string;
      description?: string;
      image?: string;
    };
  }[] = [
    {
      title: `${myCryptoPercent || 0}%`,
      description: 'Your share',
      classNames: {
        title: '!text-gold',
      },
    },
    {
      title: `$${data?.purchaseSum || 0}`,
      description: 'Purchase sum',
    },
    {
      title: String(data?.earnings || 0),
      description: 'Earned',
      image: {
        png: usdPng,
        webp: usdWebp,
      },
    },
  ];

  return (
    <div className="w-full rounded-lg bg-main-bg flex gap-2 h-14">
      {infoData.map((data, index) => (
        <div
          key={index}
          className={cn(
            'h-full flex-1 flex flex-col gap-[2px] justify-center items-center',
          )}
        >
          <div className="flex items-center gap-[2px]">
            {data.image && (
              <Picture
                className={cn('w-4 h-4 shrink-0', data.classNames?.image)}
                img={data.image.png}
                webp={data.image.webp}
                alt={data.description}
              />
            )}
            <StringMain
              weight="black"
              className={cn('!!leading-1.2', data.classNames?.title)}
            >
              {t(data.title)}
            </StringMain>
          </div>
          <StringXSmall
            className={cn(' !text-white/40', data.classNames?.description)}
          >
            {t(data.description)}
          </StringXSmall>
        </div>
      ))}
    </div>
  );
};

export { EarnInfo };
